import { encryptJSON, decryptJSON } from "./jwe.js";
import config from "../config";
const { demDxBase64Url, demDxJwtEnc } = config;
const ENCRYPTION_KEY = demDxBase64Url;
const ENCRYPTION_KID = demDxJwtEnc;

export async function encryptData({ data, ttlSeconds = 600 }) {
  const now = Math.floor(Date.now() / 1000);
  const wrapped = { data, iat: now, exp: now + ttlSeconds };
  const token = await encryptJSON(wrapped, ENCRYPTION_KEY, ENCRYPTION_KID);
  return { token };
}

export async function decryptData({ token }) {
  const obj = await decryptJSON(token, ENCRYPTION_KEY);
  const now = Math.floor(Date.now() / 1000);
  if (obj.exp && obj.exp < now) throw new Error("Token expired");
  return { data: obj.data ?? obj };
}
